const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    description: {
      type: 'string',
      title: 'توضیحات',
    },
  },
});

export default schema;
